import { lazy, Suspense } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { Spin } from 'antd';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ThemeProvider } from './contexts/ThemeContext';

// Eagerly loaded pages (initial route + auth)
import { Dashboard } from './pages/Dashboard/index';
import { Login } from './pages/Login';

// Lazy loaded pages - only fetched when navigated to
const OnlineCiroTakip = lazy(() => import('./pages/OnlineCiroTakip').then(m => ({ default: m.OnlineCiroTakip })));
const KasaRaporu = lazy(() => import('./pages/KasaRaporu').then(m => ({ default: m.KasaRaporu })));
const Bankalar = lazy(() => import('./pages/Bankalar').then(m => ({ default: m.Bankalar })));
const Borclular = lazy(() => import('./pages/Borclular').then(m => ({ default: m.Borclular })));
const Alacaklilar = lazy(() => import('./pages/Alacaklilar').then(m => ({ default: m.Alacaklilar })));
const VerilenCekler = lazy(() => import('./pages/VerilenCekler').then(m => ({ default: m.VerilenCekler })));
const AlinanCekler = lazy(() => import('./pages/AlinanCekler').then(m => ({ default: m.AlinanCekler })));
const FireRaporu = lazy(() => import('./pages/FireRaporu').then(m => ({ default: m.FireRaporu })));
const GiderlerRaporu = lazy(() => import('./pages/GiderlerRaporu').then(m => ({ default: m.GiderlerRaporu })));
const StokFifoRaporu = lazy(() => import('./pages/StokFifoRaporu').then(m => ({ default: m.StokFifoRaporu })));
const StokMaliyetRaporu = lazy(() => import('./pages/StokMaliyetRaporu').then(m => ({ default: m.StokMaliyetRaporu })));
const SatisKarlilik = lazy(() => import('./pages/SatisKarlilik').then(m => ({ default: m.SatisKarlilik })));

function PageLoader() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
      <Spin size="large" />
    </div>
  );
}

// Layout wrapper that uses Outlet for nested routes
function LayoutWrapper() {
  return (
    <ProtectedRoute>
      <Layout>
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<LayoutWrapper />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/ciro-takip" element={<OnlineCiroTakip />} />
          <Route path="/kasa-raporu" element={<KasaRaporu />} />
          <Route path="/bankalar" element={<Bankalar />} />
          <Route path="/borclular" element={<Borclular />} />
          <Route path="/alacaklilar" element={<Alacaklilar />} />
          <Route path="/verilen-cekler" element={<VerilenCekler />} />
          <Route path="/alinan-cekler" element={<AlinanCekler />} />
          <Route path="/fire-raporu" element={<FireRaporu />} />
          <Route path="/giderler" element={<GiderlerRaporu />} />
          <Route path="/stok-fifo" element={<StokFifoRaporu />} />
          <Route path="/stok-maliyet" element={<StokMaliyetRaporu />} />
          <Route path="/satis-karlilik" element={<SatisKarlilik />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;
